var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"emptycontent"}},[_c('div',{staticClass:"icon-error"}),_vm._v(" "),_c('h2',[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.t('viewer', 'Error loading {name}', { name: _vm.name })))]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }